import type { Order } from 'types/orders';
import type { User } from 'types/users';
import type { Categories } from 'store/slices/cars/types';

export enum SubscriptionStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  REFUSED = 'REFUSED',
  ARCHIVED = 'ARCHIVED',
  CANCELED = 'CANCELED',
}
export interface SubscriptionsDto {
  id: string;
  orders: Array<Order>;
  user: User;
  daysCount: number;
  daysUsed: number;
  includedCategories: Array<Categories>;
  status: SubscriptionStatus;
  endDate: Date;
  isPaid: boolean;
  price: number;
  createdAt: Date;
  userId: string;
}
